import { useState, useEffect, useMemo } from 'react';
import { Table as ATable, Empty } from '@didi-pebble/pebble-design-react';
import { i18nTranslate } from '@didi/i18n-plugin';
import classnames from 'classnames';

import { useIsMobile } from '@/utils';
import { ReactComponent as EmptyIcon } from '@/assets/images/empty.svg';

const ResponsiveTable = ({ columns, ...props }: any) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = useIsMobile();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [newColumns, responsiveColumns] = useMemo(() => {
    let newColumnsArray: any = [];
    const responsiveColumnsArray: any = [];

    if (isMobile) {
      columns.forEach((column: any) => {
        const { fixed, folded, ...rest } = column; // 去掉fixed属性

        if (folded) {
          responsiveColumnsArray.push({ folded, ...rest });
        } else {
          newColumnsArray.push(rest);
        }
      });

      // 按照folded的值排序
      responsiveColumnsArray.sort((a: any, b: any) => a.folded - b.folded);
    } else {
      newColumnsArray = columns;
    }

    return [newColumnsArray, responsiveColumnsArray];
  }, [isMobile, columns]);

  const divWidth = windowWidth - 32;

  return (
    <ATable
      locale={{
        emptyText: (
          <Empty
            image={<EmptyIcon width={96} height={96} />}
            description={
              <div className='mt-[14px] font-DiDiSansPro-Regular text-sm text-gray-8'>
                {i18nTranslate('Internal_Tools_2_CnTD_lDFG')}
              </div>
            }
            imageStyle={{ height: 96 }}
          />
        )
      }}
      expandable={
        isMobile
          ? {
              expandedRowRender: (record: any) => {
                return (
                  <div style={{ width: divWidth }} className='flex flex-wrap'>
                    {responsiveColumns.map((column: any, index: number) => {
                      return (
                        <div
                          key={index}
                          className={classnames(
                            'text-[14px] leading-[16px] text-gray-9 w-1/2 flex flex-col items-start text-left',
                            {
                              // 'items-start text-left': index % 2 === 0, // 对于偶数索引（包括0），靠左对齐
                              // 'items-end text-right': index % 2 === 1, // 对于奇数索引，靠右对齐
                              'mt-[20px]': Math.floor(index / 2) !== 0 // 如果不在第一行，添加 marginTop
                            }
                          )}
                        >
                          <div className='font-DiDiSansPro-Medium font-[500]'>
                            {typeof column.title === 'function' ? column.title() : column.title}
                          </div>
                          <div className='mt-[4px]'>
                            {column.render
                              ? column.render(record?.[column?.dataIndex], record)
                              : record?.[column?.dataIndex]}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }
            }
          : null
      }
      columns={newColumns}
      size={isMobile ? 'small' : 'large'}
      {...props}
    />
  );
};

export default ResponsiveTable;
